import { render, staticRenderFns } from "./Fuwuxiaofei.vue?vue&type=template&id=0b248dc2&"
import script from "./Fuwuxiaofei.vue?vue&type=script&lang=ts&"
export * from "./Fuwuxiaofei.vue?vue&type=script&lang=ts&"
import style0 from "./Fuwuxiaofei.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports